import api from '../api';
import { ILoginFormData, ILoginResponseData } from '../../context/UserContext';
import { getFromSessionStorage, setInSessionStorage } from '../../constants/functions';

export const handleLogin = async (userData: ILoginFormData) => {
  const url = `/consorciado/login`;
  let { group, quota, password, digit, document } = userData;
  try {
    const res = (await api.post(url, {
      grupo: group,
      quota,
      senha: password,
      digito: digit,
      cpfCnpj: document,
    })) as any;

    // garante valores de grupo, cota e dígito usando a cota logada retornada pela API
    if (!group || !quota || !digit) {
      const cotaDigito = res.consorciadoCotaDigito || '';
      if (cotaDigito.includes('/')) {
        const [grupoCota, dig] = cotaDigito.split('.');
        const [grp, cot] = grupoCota.split('/');
        group = group || grp;
        quota = quota || cot;
        digit = digit || dig;
      }

      // fallback para a primeira cota retornada quando a API não informa a cota logada
      // (ex.: login por CPF/CNPJ, em que consorciadoCotaDigito vem vazio/sem "/")
      const primeiraCota = res.consorciados?.[0];
      if (primeiraCota) {
        group = group || primeiraCota.grupo;
        quota = quota || primeiraCota.cota;
        digit = digit || primeiraCota.digito;
      }
    }

    if (!digit) {
      const consorciado = res.consorciados.find(
        (c: { grupo: string; cota: string }) =>
          parseInt(c.grupo) === parseInt(group as string) && parseInt(c.cota) === parseInt(quota as string)
      );
      digit = consorciado ? consorciado.digito : '99';
    }

    setInSessionStorage('loggedWithCpfCnpj', String(Boolean(document)));
    setInSessionStorage('access', res.consorciadoAcesso);
    setInSessionStorage('cpfCnpj', res.consorciadoCpfCnpj);
    setInSessionStorage('segmentoLogin', res.consorciadoSegmento);
    setInSessionStorage('group', group as string);
    setInSessionStorage('quota', quota as string);
    setInSessionStorage('digit', digit + '');
    return res as ILoginResponseData;
  } catch (e) {
    return e;
  }
};
export const requestPassword = async (userData: ILoginFormData) => {
  const url = `/consorciado/solicitaSenha`;
  const { document, email } = userData;

  try {
    const res = (await api.post(url, { cpf_cnpj: document, email: email })) as any;
    return res;
  } catch (e) {
    return e;
  }
};
export const getUserInfo = async () => {
  const url = `/vendedor/consorciado/dados?cpfCnpj=${getFromSessionStorage('cpfCnpj')}`;
  try {
    const res = await api.get(url, { headers: { token: getFromSessionStorage('token') } });
    return res;
  } catch (e) {
    return e;
  }
};
